import React from 'react';
import LoadingPackage from '../../pages/Common/LoadingPackage';

export default function LoadingPane() {
  return (
    <div className='flex h-full w-full items-center justify-center'>
      <LoadingPackage />
    </div>
  );
}
